import { render, staticRenderFns } from "./AgreementPromotions.vue?vue&type=template&id=66e51901&"
import script from "./AgreementPromotions.vue?vue&type=script&lang=js&"
export * from "./AgreementPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports